
var suggestionTemplate;
var suggestionOptionTemplate;
var suggestionDotTemplate;
var suggestionsContainer;
var cartSuggestionCurrentIndex = 0;
var cartSuggestionIndexTotal = 0;

var cartSuggestedItemsBuildRunning = false;

function cartSuggestedItemsBuild()
{

  if(cartSuggestedItemsBuildRunning)
    return;


  cartSuggestedItemsBuildRunning = true;


  
  suggestionTemplate = document.querySelector(".nw-cart-suggest-item-template");
  suggestionOptionTemplate = document.querySelector(".nw-cart-suggest-item-variant-template");
  suggestionsContainer = document.querySelector(".nw-cart-suggested-items");
  suggestionDotTemplate = document.querySelector(".nw-cart-suggested-items-controls-dot-template");
  suggestionDotContainer = document.querySelector(".nw-cart-suggested-items-controls-dots");
  const cartProductItems = document.querySelector('.nw-cart-suggested-items');
    fetch(window.Shopify.routes.root + "cart.js")
    .then(response => response.json())
    .then((data) => {
      cartSuggestItemsProcessResults(data);
    });    
}

async function cartSuggestItemsProcessResults(data)
{
    cleanOutExistingSuggestions();
  suggestionsShowPlaceholder(true);

  

  const uniqueProducts = new Map();
  
  //console.log(data);
  for (let index = 0; index < data.items.length; index++) {
   var nextItem = data.items[index];
   //console.log("nextItem.product_id" + nextItem.product_id);
   uniqueProducts.set(nextItem.product_id, "nextItem.product_id");
  }

  var productSuggestionCount = 0;
  const productSuggestionCountLimit = 8;

  const uniqueProductSuggestions = new Map();
  for (const [key, value] of uniqueProducts)
  {
    //console.log(`key = ${key} | value = ${value}`);
    uniqueProductSuggestions.set(key,"suggestionProduct");
  }

  var itemsToSuggest = 1;

  if(data.items.length <= 4)
  {
    itemsToSuggest = 2;
  }
  if(data.items.length <= 2)
  {
    itemsToSuggest = 4;
  }

  
  for (const [key, value] of uniqueProducts) {
    //console.log(`key = ${key} | value = ${value}`);
    var productSuggestions;
    try {
      productSuggestions = await cartSuggestItemsGetProductSuggestions(key, itemsToSuggest);
    } catch (error) {
      console.log("error getting next product suggestion, error: " + error);
      continue;
    }
    if(productSuggestions == null)
      continue;
    if(productSuggestions.products == null)
      continue;


    
    for (let index = 0; index < productSuggestions.products.length; index++) {
      if(productSuggestionCount >= productSuggestionCountLimit)
        continue;
      var suggestionData = productSuggestions.products[index];
      
      if(uniqueProductSuggestions.has(suggestionData.id))
        continue;

      //console.log("suggestionData.id to add = " + suggestionData.id);
      
      uniqueProductSuggestions.set(suggestionData.id,"suggestionProduct");
      cartSuggestionItemCreate(suggestionData, productSuggestionCount);
      productSuggestionCount++;
    }

  }
  cartSuggestionIndexTotal = productSuggestionCount;
  cartSuggestionUpdateCartButtons();
  suggestionsShowPlaceholder(false);
  cartSuggestionSetActiveCard(0);
  cartSuggestedItemsBuildRunning = false;


  //console.log('productSuggestionCount = ' + productSuggestionCount);
}

function cleanOutExistingSuggestions()
{
  //console.log('cleanOutExistingSuggestions');
  
  const currentSuggestedDotsClone = document.querySelectorAll('.nw-cart-suggested-items-controls-dot-clone');
  //console.log('currentSuggestedDots length = ' + currentSuggestedDots.length);
  currentSuggestedDotsClone.forEach((nextSuggestedDot) => {
    nextSuggestedDot.remove();
  });
  
  const currentSuggestedItems = document.querySelectorAll('.nw-cart-suggest-item-clone');
  currentSuggestedItems.forEach((nextSuggestionItem) => {
    nextSuggestionItem.remove();
  });


}

function suggestionsShowPlaceholder(showPlaceholder)
{
  var placeHolderElem =  document.querySelector('.nw-cart-suggest-item-loading');
  var controlsElem = document.querySelector('.nw-cart-suggested-items-controls');
  var currentSuggestedItemActive = document.querySelector('.nw-cart-suggest-item-clone[suggestionCardActive=true');
  if(showPlaceholder)
  {
    placeHolderElem.style.display = "block";
    controlsElem.style.display = "none";
  }
  else
  {
    placeHolderElem.style.display = "none";
    controlsElem.style.display = "flex";
    if(currentSuggestedItemActive != null)
      currentSuggestedItemActive.style.display = "block";
    
  };
}


function cartSuggestionItemCreate(suggestionData, productCount)
{
  var firstAvailableIndex = -1;
  var numberOfAvailableVariants = 0;
  for (let index = 0; index < suggestionData.variants.length; index++) {
    //debug variant data
    var nextVariant = suggestionData.variants[index];
    //console.log("nextVariant object" + JSON.stringify(nextVariant));
    //console.log("nextVariant nextVariant.name = " + nextVariant.name);
    //console.log("nextVariant nextVariant.available = " + nextVariant.available);

    if(nextVariant.available)
    {
      numberOfAvailableVariants++;
      if(firstAvailableIndex == -1)
        firstAvailableIndex = index;
    }
  }
  //console.log(suggestionData);
  //console.log(suggestionData.metafields);
  var newSuggestion = suggestionTemplate.cloneNode(true);
  var newDotNode = suggestionDotTemplate.cloneNode(true);

  if(suggestionData.type == "BUNDLE")
  {
    newSuggestion.querySelector('.nw-cart-suggest-item-data-image img').src = suggestionData.featured_image + '&height=120';
  }
  else
  {
    if(suggestionData.variants[firstAvailableIndex].featured_media != null && suggestionData.variants[firstAvailableIndex].featured_media.preview_image != null && suggestionData.variants[firstAvailableIndex].featured_media.preview_image.src != null)
      newSuggestion.querySelector('.nw-cart-suggest-item-data-image img').src = suggestionData.variants[firstAvailableIndex].featured_media.preview_image.src + '&height=120';
  }
  newSuggestion.querySelector('.nw-cart-suggest-item-data-image img').alt = suggestionData.title;
  newSuggestion.querySelector('.nw-cart-suggest-item-options-link a').href = suggestionData.url;
  newSuggestion.querySelector('.nw-cart-suggest-item-data-info-title').innerHTML  = suggestionData.title;
  newSuggestion.querySelector('.nw-cart-suggested-item-title-link').href = suggestionData.url;


  var usCurrencyOutput = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
  });


  var outputPrice = suggestionData.variants[firstAvailableIndex].price / 100;

  var prefix = "From: ";

  if(numberOfAvailableVariants == 1)
    prefix = "";

  cartSuggestionToggleOptionAdd(true, newSuggestion);

  /*
  if(suggestionData.price_min == suggestionData.price_max)
  {
    cartSuggestionToggleOptionAdd(true, newSuggestion);
    prefix = "";
  }
  else
  {
    cartSuggestionToggleOptionAdd(false, newSuggestion);
  }
  */

  newSuggestion.querySelector('.nw-cart-suggest-item-data-info-price').innerHTML  = prefix + usCurrencyOutput.format(outputPrice);
  newSuggestion.style.display = "none";
  newDotNode.style.display = "block";
  newDotNode.setAttribute('onclick','cartSuggestionSetActiveCard('+productCount+')');
  if(productCount == 0)
  {
    newSuggestion.setAttribute("suggestioncardActive", "true");
    newDotNode.setAttribute("suggestionDotActive", "true");
  }
  else
  {
    newSuggestion.setAttribute("suggestioncardActive", "false");
    newDotNode.setAttribute("suggestionDotActive", "false");
  }
  newSuggestion.setAttribute("suggestionCardIndex", productCount);
  newDotNode.setAttribute("suggestionCardIndex", productCount);
  newSuggestion.querySelector('product-form form input[name=id]').setAttribute("value", suggestionData.variants[firstAvailableIndex].id);
  newSuggestion.querySelector('product-form form input[name=id]').setAttribute("data-productid", suggestionData.id);
  newSuggestion.querySelector('product-form form').setAttribute("data-product-id", suggestionData.id);
  newSuggestion.querySelector('product-form form input[name=product-id]').setAttribute("value", suggestionData.id);

  newSuggestion.classList.remove("nw-cart-suggest-item-template");
  newSuggestion.classList.add("nw-cart-suggest-item-clone");
  newDotNode.classList.remove("nw-cart-suggested-items-controls-dot-template");
  newDotNode.classList.add("nw-cart-suggested-items-controls-dot-clone");

  //console.log("newSuggestion data follows:");
  //console.log(newSuggestion);
  
  suggestionsContainer.appendChild(newSuggestion);
  suggestionDotContainer.appendChild(newDotNode);

  //console.log('document.querySelector(".nw-cart-suggested-items") follows');
  //console.log(document.querySelector(".nw-cart-suggested-items"));

  //cartSuggestionGenerateOptions(suggestionData, productCount, newSuggestion);
  if(suggestionData.type != "BUNDLE")
  {
  cartSuggestionGenerateVariantLabel(suggestionData, productCount, newSuggestion, firstAvailableIndex);
  }
}

function cartSuggestionToggleOptionAdd(enableAdd, newSuggestion)
{
  if(enableAdd)
  {
    newSuggestion.querySelector('.nw-cart-suggest-item-add-to-cart').style.display = "block";
    newSuggestion.querySelector('.nw-cart-suggest-item-options-link').style.display = "none";
    prefix = "";
  }
  else
  {
    newSuggestion.querySelector('.nw-cart-suggest-item-add-to-cart').style.display = "none";
    newSuggestion.querySelector('.nw-cart-suggest-item-options-link').style.display = "block";
  }
}

function cartSuggestionGenerateOptions(suggestionData, productCount, newSuggestion)
{
  var hasOptions = false;
  for (let index = 0; index < suggestionData.options.length; index++) {
    var nextOption = suggestionData.options[index];
    var clonedOption = suggestionOptionTemplate.cloneNode(true);
    clonedOption.style.display = "block";

    clonedOption.querySelector('.nw-cart-suggest-item-variant-select').innerHTML = "";
    clonedOption.querySelector('.nw-cart-suggest-item-variant-select').innerHTML += "<option>Select "+nextOption.name+"</option>";
    var availableOptionsCount = 0;

    //console.log("nextOption.name = " + nextOption.name + " | nextOption.values.length = " + nextOption.values.length);
    for (let variantIndex = 0; variantIndex < nextOption.values.length; variantIndex++) {
      var nextVariantName = nextOption.values[variantIndex];
      //console.log('nextVariantName = ' + nextVariantName);
      var variantDataMatch = cartSuggestionGetVariantData(nextVariantName, suggestionData);
      //console.log('variantDataMatch');
      //console.log(variantDataMatch);
      if(variantDataMatch.available)
      {
        availableOptionsCount++;
        clonedOption.querySelector('.nw-cart-suggest-item-variant-select').innerHTML += '<option value="'+variantDataMatch.id+'|'+suggestionData.id+'">'+nextVariantName+'</option>';
      }
    }
    if(availableOptionsCount > 1)
    {
      newSuggestion.querySelector('.nw-cart-suggested-item-variants').appendChild(clonedOption);
      hasOptions=true;
    }
  }

  if(hasOptions)
  {
    cartSuggestionToggleOptionAdd(true,newSuggestion);
  }
  
  
}

function cartSuggestionGenerateVariantLabel(suggestionData, productCount, newSuggestion, variantShowIndex)
{
  var hasOptions = false;
  for (let index = 0; index < suggestionData.options.length; index++) {
    var nextOption = suggestionData.options[index];
    var clonedOption = suggestionOptionTemplate.cloneNode(true);
    clonedOption.style.display = "block";

    clonedOption.querySelector('.nw-cart-suggest-item-variant-select').remove();
    //clonedOption.querySelector('.nw-cart-suggest-item-variant-select').innerHTML += "<option>Select "+nextOption.name+"</option>";
    var availableOptionsCount = 0;

    //console.log("nextOption.name = " + nextOption.name + " | nextOption.values.length = " + nextOption.values.length);
    //console.log("variantShowIndex = " +variantShowIndex);
    for (let variantIndex = 0; variantIndex < nextOption.values.length; variantIndex++) {
      //console.log("variantShowIndex = " + variantShowIndex + " | variantIndex = " + variantIndex);
      if(variantShowIndex != variantIndex)
      {
        continue;
      }
      var nextVariantName = nextOption.values[variantIndex];
      //console.log('nextVariantName = ' + nextVariantName);
      var variantDataMatch = cartSuggestionGetVariantData(nextVariantName, suggestionData);
      if(variantDataMatch.available)
      {
        availableOptionsCount++;
        clonedOption.innerHTML += '<div class="nw-cart-suggested-item-option-info" ><div class="nw-cart-suggested-item-option-info-label">'+ nextOption.name + '</div>: <div class="nw-cart-suggested-item-option-info-value">'+nextVariantName+ '</div></div>';
      }
    }
    if(availableOptionsCount >= 1)
    {
      newSuggestion.querySelector('.nw-cart-suggested-item-variants').appendChild(clonedOption);
      hasOptions=true;
    }
  }

  if(hasOptions)
  {
    cartSuggestionToggleOptionAdd(true,newSuggestion);
  }
  
  
}

function cartSuggestionVariantOptionChange(sendingObject)
{
  var splitOptionData = sendingObject.value.split('|');
  var variantId = splitOptionData[0];
  var productId = splitOptionData[1];

  //console.log('cartSuggestionVariantOptionChange sendingObject.value = ' + sendingObject.value);
  var queryBuilder = '.nw-cart-suggest-item-add-to-cart product-form form[data-product-id="'+productId+'"] input[name="id"]';
  //console.log('cartSuggestionVariantOptionChange queryBuilder = ' + queryBuilder);
  suggestionsContainer.querySelector(queryBuilder).setAttribute("value", variantId);
}

function cartSuggestionGetVariantData(variantName, suggestionData)
{
  for (let index = 0; index < suggestionData.variants.length; index++) {
    var nextVariant = suggestionData.variants[index];
    //console.log('cartSuggestionGetVariantData nextVariant.options.length = ' + nextVariant.options.length);
    for (let variantOptionIndex = 0; variantOptionIndex < nextVariant.options.length; variantOptionIndex++) {
      var nextOption = nextVariant.options[variantOptionIndex];
      //console.log('cartSuggestionGetVariantData nextOption = ' + nextOption);
      if(variantName == nextOption)
        return nextVariant;

    }
  }
}


function cartSuggestionMoveForward()
{
  if(cartSuggestionCurrentIndex == cartSuggestionIndexTotal - 1 )
  {
    return;
  }
  cartSuggestionCurrentIndex++;
  cartSuggestionSetActiveCard(cartSuggestionCurrentIndex);
}

function cartSuggestionMoveBack()
{
  if(cartSuggestionCurrentIndex == 0 )
  {
    return;
  }

  cartSuggestionCurrentIndex--;
  cartSuggestionSetActiveCard(cartSuggestionCurrentIndex);
}

function cartSuggestionUpdateCartButtons()
{
  const backButton =  document.querySelector('.nw-cart-suggested-items-controls .nw-cart-suggested-items-controls-button-back ');
  const forwardButton =  document.querySelector('.nw-cart-suggested-items-controls .nw-cart-suggested-items-controls-button-forward ');
  if(cartSuggestionCurrentIndex == 0 )
  {
    backButton.classList.remove("nw-cart-suggested-items-controls-button-enabled");
    backButton.classList.add("nw-cart-suggested-items-controls-button-disabled");
  }
  else
  {
    backButton.classList.add("nw-cart-suggested-items-controls-button-enabled");
    backButton.classList.remove("nw-cart-suggested-items-controls-button-disabled");
  }


  if(cartSuggestionCurrentIndex == cartSuggestionIndexTotal - 1 )
  {
    forwardButton.classList.remove("nw-cart-suggested-items-controls-button-enabled");
    forwardButton.classList.add("nw-cart-suggested-items-controls-button-disabled");
  }
  else
  {
    forwardButton.classList.add("nw-cart-suggested-items-controls-button-enabled");
    forwardButton.classList.remove("nw-cart-suggested-items-controls-button-disabled");
  }
  
}

function cartSuggestionSetActiveCard(activeCardIndex)
{
  const previousActiveCard =  document.querySelector('.nw-cart-suggested-items .nw-cart-suggest-item[suggestioncardActive="true"] ');
  const previousActiveDot =   document.querySelector('.nw-cart-suggested-items-controls-dot-clone[suggestionDotActive="true"] ');

  if(previousActiveCard == null || previousActiveDot == null)
    return;
  
  previousActiveCard.setAttribute("suggestioncardActive", "false");
  previousActiveDot.setAttribute("suggestionDotActive", "false");
  previousActiveCard.style.display = "none";
  
  const newActiveCard = document.querySelector('.nw-cart-suggested-items .nw-cart-suggest-item[suggestioncardindex="'+activeCardIndex+'"] ');
  const newActiveDot = document.querySelector('.nw-cart-suggested-items-controls-dot-clone[suggestioncardindex="'+activeCardIndex+'"] ');
  newActiveCard.setAttribute("suggestioncardActive", "true");
  newActiveDot.setAttribute("suggestionDotActive", "true");
  newActiveCard.style.display = "block";
  cartSuggestionCurrentIndex = activeCardIndex;

  cartSuggestionUpdateCartButtons();
}

async function cartSuggestItemsGetProductSuggestions(productId, resultLimit)
{
  const cartProductRecommendationsSection = document.querySelector('.nw-cart-suggested-items');
  var jsonDataResult;
  const recommendationStringPath = "recommendations/products.json?section_id=nw-cart-suggested-items&product_id="+productId+"&limit="+resultLimit;
  //const recommendationStringPath = "recommendations/products?section_id=ProductInfo-template--15914195714115__main&product_id="+productId+"&limit="+resultLimit;
  await fetch(window.Shopify.routes.root + recommendationStringPath)
    .then(response => response.json())
    .then((data) => {
      //console.log(data);
     jsonDataResult = data;
  });  
  return jsonDataResult;
}


addEventListener("DOMContentLoaded", (event) => {
    cartSuggestedItemsBuild();
});